/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon24Solid = forwardRef('ArrowFigureACircleRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM6 12a1 1 0 0 1 1-1h8.039l-2.293-2.293a1 1 0 0 1 1.414-1.414l3.006 3.006c.94.94.94 2.463 0 3.402l-3.006 3.006a1 1 0 0 1-1.414-1.414L15.039 13H7a1 1 0 0 1-1-1Z" })));
});
